// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';
import { useLocalMessage } from '@Helpers/';
import DividerSeries from './WidgetFormCommon/DividerSeries';
import SerieCard from './Serie/SerieCard';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { ICONS } from '@Constants/iconsApp';
import _ from 'lodash';
import { Form } from 'antd';

import './SeriesField.scss';

interface SeriesFieldProps {
    form: FormInstance;
    textField?: boolean;
    lineField?: boolean;
    counterField?: boolean;
}

export const SeriesField = ({ form, textField, lineField, counterField }: SeriesFieldProps): ReactElement | null => {
    const i = useLocalMessage();

    return (
        <Form.List
            name="series"
            rules={[
                {
                    validator: (__, value) => (_.isEmpty(value) && !textField ? Promise.reject() : Promise.resolve()),
                },
            ]}
        >
            {(fields, { add, remove }, errors): ReactElement => {
                return (
                    <>
                        <DividerSeries />

                        {fields.map((field, index) => (
                            <SerieCard
                                key={field.key}
                                form={form}
                                field={field}
                                index={index}
                                remove={remove}
                                textField={textField}
                                lineField={lineField}
                                counterField={counterField}
                            />
                        ))}

                        {fields.length === 0 && (
                            <div className="series-field__no-item">{i('dashboard.serie.no-series')}</div>
                        )}

                        <THButton
                            type="link"
                            onClick={() =>
                                add({
                                    periodDateField: '_createdAt',
                                    dateField: '_createdAt',
                                })
                            }
                            danger={!!errors.errors.length}
                            icon={<ICONS.PlusIcon />}
                        >
                            {i('dashboard.serie.add')} {!!errors.errors.length && `(${i('dashboard.serie.required')})`}
                        </THButton>
                    </>
                );
            }}
        </Form.List>
    );
};
